import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Video from '../../Video/DynamicVideoPlayer';
import arrow_1 from '../../../../images/arrow_1.svg';
import arrow_2 from '../../../../images/arrow_2.svg';

export const Wrapper = styled.div`
  list-style: none;
  height: 100%;
  width: 100%;
  position: relative;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.pc-money-step {
      &:first-child {
        &:after {
          position: absolute;
          z-index: 2;
          content: '';
          width: 60px;
          height: 40px;
          background-image: url(${arrow_1});
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
      &:nth-child(2) {
        &:after {
          position: absolute;
          z-index: 2;
          content: '';
          width: 60px;
          height: 40px;
          background-image: url(${arrow_2});
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
      &:after {
        top: 60%;
        right: -18%;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.pc-money-step {
      &:first-child {
        &:after {
          width: 80px;
          height: 50px;
        }
      }
      &:nth-child(2) {
        &:after {
          width: 80px;
          height: 50px;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.pc-money-step {
      &:first-child {
        &:after {
          width: 107px;
          height: 61px;
        }
      }
      &:nth-child(2) {
        &:after {
          width: 107px;
          height: 61px;
        }
      }
      &:after {
        top: 55%;
        right: -15%;
      }
    }
  }
`;

export const Header = styled.div`
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: 265px;
  height: auto;

  h3,
  p {
    color: ${({ theme, headingColor }) =>
      headingColor ? theme.colors[headingColor] : 'inherit'};
  }

  P {
    font-size: 16px;
    line-height: 24px;
  }

  h3 {
    font-size: 22px;
    line-height: 28px;
  }

  &.left {
    p {
      text-align: left;
    }
  }

  &.right {
    p {
      text-align: right;
    }
  }

  &.center {
    p {
      text-align: center;
    }
  }

  /* remove padding, as the videos have alot of vertical white-space, and reduce the height as we dont have padding */
  &.video-asset {
    min-height: 90px;
    padding-bottom: 0;
  }

  ${Wrapper}.pc-money-step & {
    min-height: unset;
    margin: 1rem auto;
    h3 {
      font-size: 2rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 320px;

    /* set a min-height for the videos to align the headings */
    &.video-asset {
      min-height: 170px;
    }

    ${Wrapper}.pc-money-step & {
      h3 {
        font-size: 2rem;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.pc-money-step & {
      h3 {
        font-size: 2.5rem;
      }
    }
  }
`;

export const ScreenNumber = styled.div`
  display: none;

  p {
    /* font-weight: ${({ theme }) => theme.fontWeights.semiBold}; */
    font-variant: tabular-nums;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    line-height: 1;
    font-size: 24px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    background-color: ${({ theme }) => theme.colors.velvet};
    ${Wrapper}.product-step-red &,
    &.pc-red {
      background-color: ${({ theme }) => theme.colors['pc-red']};
    }
    border-radius: 100%;
    height: 50px;
    width: 50px;
    margin: 0 auto 20px;
    align-items: center;
    justify-content: center;
  }
`;

export const PhoneVideo = styled(Video)`
  height: 100%;
  width: 100%;
  box-shadow: none;
  border: none;
  background-color: transparent;
  /* Set the aspect ratio for the phone videos */
  padding-top: calc(684 / 446 * 80%);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: auto;
    height: 526px;
  }
`;

export const StyledImage = styled(Image)`
  img {
    margin: 0 auto;
  }
`;

export const Body = styled.div`
  margin: 0 auto 2rem;
  max-width: 265px;
  p {
    font-size: 14px;
  }

  ${Wrapper}.pc-money-step & {
    margin: 0 auto 1rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 320px;
    padding: 5px;
    p {
      font-size: 16px;
    }
  }
`;
